import SetUpPassword from 'src/features/auth/components/templates/set-up-password';

export const SetUpPasswordContainer = () => {
  return <SetUpPassword />;
};
